

import loadComponents from 'gia/loadComponents';
import config from 'gia/config';


import Menu from './menu'
import Animation from './animation'
import Retailers from './retailers'
import Projects from './projects'
import Services from './services'
import Roll from './roll'
import Clients from './clients'
import Pin from './pin'
import Slider from './slider'




import lazySizes from 'lazysizes';

import owd from '../owd/owd';

import CustomCursor from './custom-cursor';
import CustomHover from './custom-hover';
import '../components/cursor-mode';
import '../components/cursor-hover';
import '../components/cursor-theme';
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import ScrollToPlugin from 'gsap/ScrollToPlugin.js';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

class App {

  constructor($) {
    this.create()
  }

  create() {

      lazySizes.init()
      config.set('log', false); // disables unnecessary console.log calls

      const app = new owd.App();
      app.use('customCursor', CustomCursor);
      app.use('customHover', CustomHover);
      app.run();

      const components = {

        Animation: Animation,
        Projects: Projects,
        Services: Services,
        Roll: Roll,
        Clients: Clients,
        Pin: Pin,
        Slider: Slider
      }

      loadComponents(components)

      
     

  }


}

module.exports = App
